import React from 'react';

export const ManageGroup = (props) => {
    const { width, height, action } = props
    const fill = action?"#202020":"#7D86A9"
    // #7D86A9
    return (
        <svg width={width} height={height} viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" >

            <title>ic_manage_group</title>
            <desc>Created with Sketch.</desc>
            <g id="Web-Notification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="01_Dashboard" transform="translate(-22.000000, -290.000000)" fill={fill} fillRule="nonzero">
                    <g id="sidemenu" transform="translate(0.000000, 70.000000)">
                        <g id="item" transform="translate(0.000000, 208.000000)">
                            <g id="ic_manage_group" transform="translate(22.000000, 12.000000)">
                                <rect id="Rectangle-path" x="2.42857143" y="2.42857143" width="5.51917143" height="12.1428571"></rect>
                                <polygon id="Rectangle-path" points="9.05225714 2.42857143 14.5714286 2.42857143 14.5714286 3.79828571 9.05225714 3.79828571"></polygon>
                                <rect id="Rectangle-path" x="9.05225714" y="4.58125714" width="5.51917143" height="1.37457143"></rect>
                                <rect id="Rectangle-path" x="9.05225714" y="6.73928571" width="5.51917143" height="1.36874286"></rect>
                                <rect id="Rectangle-path" x="9.05225714" y="8.89197143" width="5.51917143" height="1.36874286"></rect>
                                <polygon id="Rectangle-path" points="9.05225714 11.0446571 14.5714286 11.0446571 14.5714286 12.4187429 9.05225714 12.4187429"></polygon>
                                <polygon id="Rectangle-path" points="9.05225714 13.2017143 14.5714286 13.2017143 14.5714286 14.5714286 9.05225714 14.5714286"></polygon>
                                <path d="M0,0 L0,17 L17,17 L17,0 L0,0 Z M16.0285714,16.0285714 L0.971428571,16.0285714 L0.971428571,0.971428571 L16.0285714,0.971428571 L16.0285714,16.0285714 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}